import { useEffect, useState } from "react";

export interface UseIdentityScopeVersionOptions {
  events?: readonly string[];
}

const DEFAULT_SCOPE_EVENTS = [
  "app:auth-changed",
  "app:tenant-changed",
] as const;

export const useIdentityScopeVersion = ({
  events = DEFAULT_SCOPE_EVENTS,
}: UseIdentityScopeVersionOptions = {}): number => {
  const [scopeVersion, setScopeVersion] = useState(0);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const handleScopeChange = () => {
      setScopeVersion((current) => current + 1);
    };

    for (const eventName of events) {
      window.addEventListener(eventName, handleScopeChange);
    }

    return () => {
      for (const eventName of events) {
        window.removeEventListener(eventName, handleScopeChange);
      }
    };
  }, [events]);

  return scopeVersion;
};
